import React from 'react';
import { useTitle } from "fearless-common-ui";
import {concepts} from 'fearless-common';
import Pages from "../components/layout/Pages";
import {routes} from "../utils";
import {buildClientReferenceId, stripePriceTables} from "../utils/stripe";
import StripePricingTable, {PRICING_TABLE_PRODUCT} from "../components/StripePricingTable";
import useAuth from "../components/hooks/useAuth";

/**
 * Page on which the user can get an individual subscription.
 */
export default function GetIndividualSubscription() {
    useTitle(`Get individual ${concepts.Subscription.toLowerCase()}`);
    const { user } = useAuth();

    return (
        <Pages.UserBase
            header={[
                { label: concepts.Subscriptions, href: routes.subscriptions() },
                { label: `Get ${concepts.Photo51} ${concepts.Subscription}` },
            ]}
        >
          <Pages.BackButton href={routes.subscriptions()}>{concepts.Subscriptions}</Pages.BackButton>
          {user && (
            <StripePricingTable
              tableId={stripePriceTables.INDIVIDUAL}
              clientReferenceId={buildClientReferenceId('user', user.id)}
              postPrices={[PRICING_TABLE_PRODUCT.INSTITUTE]}
            />
          )}
        </Pages.UserBase>
    );
}
